module.exports = __webpack_public_path__ + "media/site_templates/www.roofingcompany.net.au/images/splash-9b50604a69dabfeffe01b0324539a486.jpg";